'use strict';

var account_create_model = require('./account_create.model.js');
var otp_generated_model = require('./otp_generated.model.js');
var otp_redeemed_model = require('./otp_redeemed.model.js');
var otp_requested_model = require('./otp_requested.model.js');
var page_view_model = require('./page_view.model.js');
var password_created_model = require('./password_created.model.js');
var password_updated_model = require('./password_updated.model.js');
var prompt_converted_model = require('./prompt_converted.model.js');
var prompt_shown_model = require('./prompt_shown.model.js');
var user_login_model = require('./user_login.model.js');
var user_payment_model = require('./user_payment.model.js');

var schemas = {
  prompt_shown: prompt_shown_model,
  prompt_converted: prompt_converted_model,
  account_create: account_create_model,
  user_login: user_login_model,
  user_payment: user_payment_model,
  page_view: page_view_model,
  otp_requested: otp_requested_model,
  otp_generated: otp_generated_model,
  otp_redeemed: otp_redeemed_model,
  password_created: password_created_model,
  password_updated: password_updated_model
};
var gadgetSchemas = schemas;

module.exports = gadgetSchemas;
//# sourceMappingURL=index.js.map
